import { useEffect, useMemo, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
// @ts-ignore — AuthContext es JSX
import { useAuth } from "@/contexts/AuthContext";
import { db } from "../../firebase/config";

export type BordonaAccountRole = "teacher" | "student";

const STUDENT_PROFILES = "bordona_student_profiles";

export function useBordonaAccount() {
  const { user, loading: authLoading, accessProfile, profesorData, accountType } =
    useAuth();
  const [studentProfileExists, setStudentProfileExists] = useState(false);
  const [studentCheckDone, setStudentCheckDone] = useState(false);

  useEffect(() => {
    if (!user?.uid) {
      setStudentProfileExists(false);
      setStudentCheckDone(false);
      return;
    }

    let cancelled = false;
    setStudentCheckDone(false);

    getDoc(doc(db, STUDENT_PROFILES, user.uid))
      .then((snap) => {
        if (!cancelled) {
          setStudentProfileExists(snap.exists());
          setStudentCheckDone(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStudentProfileExists(false);
          setStudentCheckDone(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [user?.uid]);

  const isTeacher = useMemo(() => {
    if (!user || !studentCheckDone) return false;
    const type = accountType || accessProfile?.accountType;
    if (type === "estudiante") return false;
    if (studentProfileExists) return false;
    if (profesorData && !profesorData._perfilTemporal) return true;
    return type === "profesor";
  }, [
    user,
    studentCheckDone,
    studentProfileExists,
    profesorData,
    accountType,
    accessProfile?.accountType,
  ]);

  const role = useMemo((): BordonaAccountRole | null => {
    if (!user || !studentCheckDone) return null;
    if (isTeacher) return "teacher";
    return "student";
  }, [user, studentCheckDone, isTeacher]);

  const isLoading = authLoading || (!!user && !studentCheckDone);

  return {
    role,
    isTeacher,
    isLoading,
    isAuthenticated: !!user,
  };
}
